import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';

import ActionLink from '../../builder/ActionLink';
import Message from '../../builder/Message';
import Model from '../../builder/Model';
import Range from '../../builder/Range';

const ContainerSliders = (props) => {
	let width = `config.layout.${props.section}.width`;
	let num_cols = `config.layout.${props.section}.num_cols`;
	const cols_prop = `config.layout.${props.section}.cols_prop`;

	let layout = props?.layout ?? { num_cols:1 };

	switch(props.section) {
		case 'stage':
		case 'stage_mosaic':
		case 'brackets_mosaic':
		case 'galleries_mosaic':
			layout.width = layout.layout_width ?? layout.width;
			if(layout.width == undefined) layout.width = 70;
			if(layout.num_cols == undefined) layout.num_cols = 1;
			if(layout.cols_prop == undefined) layout.cols_prop = 40;
			if(layout.type == undefined || layout.type != 2) {
				layout.num_cols = layout.layout_num_cols ?? layout.num_cols;
				layout.cols_prop = layout.layout_cols_prop ?? layout.cols_prop;
			}
			break;
	}

	const display_only_width_slider = (props.display_only_width_slider != undefined) ? props.display_only_width_slider : false;

	const max_width_recommendation = (props.max_width_recommendation != undefined) ? parseInt(props.max_width_recommendation) : false;
	const min_width_recommendation = (props.min_width_recommendation != undefined) ? parseInt(props.min_width_recommendation) : false;

	return (
		<div class={props.classes}>
			<Model model={props.layout} change={props.change}>
				{((max_width_recommendation && props.layout.width > max_width_recommendation) || (min_width_recommendation && props.layout.width < min_width_recommendation)) && (
					<Message
						_class={{ other:'in_top' }}
					>
						{(max_width_recommendation && props.layout.width > max_width_recommendation) && (
							<p><FormattedMessage id="For optimized visualization, we recommend not to exceed {max}%." values={{max:max_width_recommendation}} /></p>
						)}

						{(min_width_recommendation && props.layout.width < min_width_recommendation) && (
							<p><FormattedMessage id="For optimized visualization, we recommend not to go less than {min}%." values={{min:min_width_recommendation}} /></p>
						)}
					</Message>
				)}

				<Range
					min={40}
					max={100}
					name={width}
					value={layout.width}
					default={(max_width_recommendation) ? max_width_recommendation : ((min_width_recommendation) ? min_width_recommendation : 60)}
					step={10}
					_class={{size:50, first:true}}
				>Container width</Range>

				{((layout.type == undefined || layout.type != 2) && !display_only_width_slider) && (
					<Range
						min={1}
						max={2}
						name={num_cols}
						value={layout?.num_cols ?? 1}
						default={1}
						_class={{size:50}}
					>Container columns</Range>
				)}

				{((layout.type == undefined || layout.type != 2) && layout.num_cols == 2 && !display_only_width_slider) && (
					<Range
						min={30}
						max={70}
						name={cols_prop}
						value={layout?.cols_prop ?? 35}
						default={35}
						step={10}
						_class={{size:50}}
					>Columns proportion</Range>
				)}
			</Model>

			{(!display_only_width_slider) && (
				<ul class="not_in_top gui_margined_children_low_v">
					<li class="gui_padded_icon gui_small_icon knk-settings"><ActionLink _href="#design/container">Set up the generic layout settings</ActionLink></li>
				</ul>
			)}
		</div>
	)
}

export default injectIntl(ContainerSliders);